import React, { Fragment, useRef } from "react";
import PropTypes from "prop-types";

EAUploadButton.propTypes = {
    id: PropTypes.string.isRequired,
    testId: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onFileChange: PropTypes.func.isRequired,
    formFactory: PropTypes.any.isRequired,
    disabled: PropTypes.any.isRequired,
    loading: PropTypes.any.isRequired,
    accept: PropTypes.string,
};

function EAUploadButton({ id, testId, label, onFileChange, formFactory, disabled, loading, accept, ...rest }) {
    const inputFile = useRef(null);

    function handleUploadClick() {
        inputFile.current.click();
    }

    return (
        <Fragment>
            <input type="file" accept={accept ? accept : "*"} onChange={onFileChange} ref={inputFile} style={{ display: "none" }} />
            {formFactory.renderButton(
                id,
                testId,
                label,
                () => {
                    handleUploadClick();
                },
                { style: { marginRight: "auto" }, disabled: disabled, loading: loading }
            )}
        </Fragment>
    );
}

export default EAUploadButton;
